import { ReactNode, useState, useEffect } from "react";
import { Navigate, useLocation } from "react-router-dom";
import useAuth from "../../context/AuthContext";
import { Loading } from "../../components/Loading";

type Props = {
  children: ReactNode;
};

const Authenticated = ({ children }: Props) => {
  const auth = useAuth();
  const location = useLocation();
  const [requestedLocation, setRequestedLocation] = useState<string | null>(
    null
  );

  useEffect(() => {
    if (!auth.isAuthenticated && location.pathname !== requestedLocation) {
      setRequestedLocation(location.pathname);
    }
  }, [auth.isAuthenticated, location.pathname, requestedLocation]);

  if (!auth.isInitialized) {
    return <Loading />;
  }

  if (!auth.isAuthenticated) {
    return <Navigate to="/" />;
  }

  if (requestedLocation && location.pathname !== requestedLocation) {
    const to = requestedLocation;
    setRequestedLocation(null);
    return <Navigate to={to} />;
  }

  return <>{children}</>;
};

export default Authenticated;
